import {useState} from 'react';
import {motion} from 'framer-motion';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/modules/lucky_wheel/spin-button';
import {makeSpin} from '../../../../reducers/lucky-wheel/actions';

import Timer from './timer';

export default () => {
    const {wheel, timeout} = useSelector(Selector),
          dispatch = useDispatch();

    const [hovered, setHovered] = useState(false);

    if(wheel.status === "none")
        return (
            <Timer timeout={timeout}>
                <>
                    {
                        wheel.button
                        ? <div className="spin-button disabled"></div>
                        : (
                            <motion.div
                                className="spin-button"
                                onHoverStart={() => setHovered(true)}
                                onHoverEnd={() => setHovered(false)}
                                onClick={e => {
                                    dispatch(makeSpin());
                                }}
                                animate={{
                                    scale: hovered ? 1 : [1, 1.015, 1],
                                }}
                                transition={hovered ? {
                                    duration: 0.15,
                                } : {
                                    duration: 1.6,
                                    repeat: Infinity,
                                    ease: 'easeInOut',
                                }}
                            />
                        )
                    }
                </>
            </Timer>
        )

    if(wheel.status === "spin" || wheel.status === "spin-finale")
        return <div className="spin-button spinning"></div>;

    return (
        <div className="spin-button timer">
            <span>06:23:12</span>
        </div>
    )
}